import actionTypes from '../constants/action-types';

const setHelpCenterIntegration = (type) => ({
  type: actionTypes.SET_HELP_CENTER_INTEGRATION,
  payload: {
    type,
  },
});

export default setHelpCenterIntegration;
